<!-- Cloud background for login/register -->
<div #vantaBg class="vanta-background">
  <!-- Login Form -->
  <div class="form-container active" id="loginForm">
    <div class="brand-header">
      <div class="brand-logo">
        <span>☁️</span>
        <span>Feel The Freedom</span>
      </div>
      <div class="brand-tagline">
        Power up your journey with sustainable mobility
      </div>
    </div>
    <div class="success-banner" id="loginSuccess"></div>
    <form id="loginFormElement">
      <div class="input-group">
        <label class="input-label" for="loginEmail">Email Address</label>
        <input
          #loginEmail
          id="loginEmail"
          type="email"
          placeholder="you@email.com"
          [(ngModel)]="loginModel.username"
          name="loginEmail"
          class="input-field"
          required
          (input)="onLoginUsernameInput(loginEmail.value)"
        />
        <div class="error-text" id="loginEmailError">
          Please enter a valid email
        </div>
      </div>

      <div class="input-group">
        <label class="input-label" for="loginPassword">Password</label>
        <input
          id="loginPassword"
          type="password"
          placeholder="Enter your password"
          [(ngModel)]="loginModel.password"
          name="loginPassword"
          class="input-field"
          required
        />
        <div class="error-text" id="loginPasswordError">
          Password is required
        </div>
      </div>

      <button type="submit" class="primary-button" [disabled]="loginLoading">
        Start Riding
      </button>
    </form>

    <!-- Error/Success Messages -->
    <div id="loginSuccess" class="success-message"></div>
    <div *ngIf="loginError" class="error-banner">{{ loginError }}</div>

    <div style="text-align: center; margin-top: 16px">
      <button class="switch-link" id="forgotPassword" style="font-size: 14px">
        Forgot password?
      </button>
    </div>

    <div class="divider-line"><span>or</span></div>

    <div class="switch-mode">
      New to Mapsy?
      <button class="switch-link" id="switchToRegister">
        Join the revolution
      </button>
    </div>
  </div>

  <!-- Register Form -->
  <div class="form-container slide-in-left" id="registerForm">
    <div class="brand-header">
      <div class="brand-logo">
        <span>☀️</span>
        <span>Join the Ride</span>
      </div>
      <div class="brand-tagline">Start your electric journey today</div>
    </div>
    <div class="success-banner" id="registerSuccess"></div>
    <form id="registerFormElement">
      <div class="input-group">
        <label class="input-label" for="registerName">Username</label>
        <input
          type="text"
          class="input-field"
          id="registerName"
          placeholder="John Doe"
          required
        />
        <div class="error-text" id="registerNameError">Name is required</div>
      </div>

      <div class="input-group">
        <label class="input-label" for="registerEmail">Email Address</label>
        <input
          type="email"
          class="input-field"
          id="registerEmail"
          placeholder="your@email.com"
          required
        />
        <div class="error-text" id="registerEmailError">
          Please enter a valid email
        </div>
      </div>

      <div class="input-group">
        <label class="input-label" for="registerPassword">Password</label>
        <div class="input-with-eye">
          <input
            type="password"
            class="input-field"
            id="registerPassword"
            placeholder="Min. 8 characters"
            required
            [(ngModel)]="registerModel.password"
            name="registerPassword"
            (focus)="toggleRules(true)"
            (blur)="toggleRules(false)"
            (input)="onPasswordInput()"
          />
          <button type="button" class="show-hide-btn" id="togglePassword">
            <img
              src="login/password-eye-royalty.png"
              alt="Show or hide password"
            />
          </button>
        </div>
        <div class="error-text" id="registerPasswordError">
          Password must be at least 8 characters, include uppercase, number, and
          symbol.
        </div>

        <!-- Password strength meter and rules, hidden initially -->
        <div
          class="password-strength-container hide"
          id="passwordStrengthContainer"
        >
          <div class="password-strength-bar">
            <div id="passwordStrengthFill"></div>
          </div>
          <ul class="password-rules-list" id="passwordRulesList">
            <li id="pwLength" class="pw-rule">Minimum 8 characters</li>
            <li id="pwUpper" class="pw-rule">At least one uppercase letter</li>
            <li id="pwNumber" class="pw-rule">At least one number</li>
            <li id="pwSymbol" class="pw-rule">At least one symbol</li>
          </ul>
        </div>
      </div>

      <!-- Confirm password input with show/hide button -->
      <div class="input-group">
        <label class="input-label" for="registerConfirmPassword"
          >Confirm Password</label
        >
        <div class="input-with-eye">
          <input
            type="password"
            class="input-field"
            id="registerConfirmPassword"
            placeholder="Re-enter password"
            required
            [(ngModel)]="registerModel.confirmPassword"
            name="registerConfirmPassword"
          />
          <button
            type="button"
            class="show-hide-btn"
            id="toggleConfirmPassword"
          >
            <img
              src="login/password-eye-royalty.png"
              alt="Show or hide password"
            />
          </button>
        </div>
        <div class="error-text" id="registerConfirmPasswordError">
          Passwords do not match
        </div>
      </div>

      <div class="input-group">
        <label class="input-label" for="registerDeviceId">Device ID</label>
        <input
          type="text"
          class="input-field"
          id="registerDeviceId"
          placeholder="Enter your Device ID"
          required
          [(ngModel)]="registerModel.deviceId"
          name="registerDeviceId"
        />
        <div class="error-text" id="registerDeviceIdError">
          Device ID is required
        </div>
      </div>

      <button type="submit" class="primary-button" [disabled]="registerLoading">
        Create Account
      </button>
    </form>

    <div class="divider-line"><span>or</span></div>

    <div class="switch-mode">
      Already riding with us?
      <button class="switch-link" id="switchToLogin">Sign in</button>
    </div>
  </div>
</div>
